<div class="form__item">
  <div class="form__item-label" *ngIf="to?.label">
    <label>{{ to?.label }}:</label>
  </div>
  <div class="form__item-control">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
